import { Component, Input } from '@angular/core';
import { SupportParametric } from 'src/app/shared/interfaces/supporarea';

@Component({
  selector: 'app-frequentquestions',
  templateUrl: './frequentquestions.component.html',
  styleUrls: ['./frequentquestions.component.scss']
})
export class FrequentquestionsComponent {
  @Input() code:string = '';
  @Input() description:string = '';
  @Input()
  supportParametric!: SupportParametric;
  

}
